/**
 * URL parameter for the assignment board's search. The skill routing view uses "search";
 * sharing it made a search typed there silently filter the board, which also switches
 * folder ticks to schedule-only (see board-selection.js).
 */
export const ASSIGNMENT_SEARCH_PARAM = "assignmentSearch"
